import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { DconConfigAPI } from '../../features/dfte-grid-view/config/config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompareserviceService {
  fromTable: boolean = false;
  nodeBaseUrl = DconConfigAPI.NODE_URL;
  options: any;
  instanceName: string;
  sourceInstance: any;
  batchStatus: any;
  targetInstance: any;
  configType: string = 'load';
  tabval = new BehaviorSubject('select');
  batchKey: string = null;
  authorizationData: any;
  projId: string;
  selectInstanceListTarget: any;
  instanceList: string;
  configObj: any;
  tracksFromTable: any;
  batchKeyDetails: any;
  requestedBy: string;
  selectDateValue: any;
  endDateValue: any;
  Base_UI_BOT = DconConfigAPI.UI_PATH;
  configFileList: any;
  token: any;
  authToken: string;
  localstorageToken = localStorage.getItem('authToken');

  Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
  constructor(private https: HttpClient, private dataSrv: DataService) {
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.requestedBy = this.dataSrv.loggedUserId;
    this.projId = this.dataSrv.projectID;
    console.log('val', this.projId);
    this.dataSrv.token.subscribe((val) => {
      this.token = val;
      this.authToken = 'Bearer ' + this.token;
    });
  }

  getisTrainStopUrl() {
    const isTrainStopUrl = this.dataSrv.getisTrainStopUrl();
    return isTrainStopUrl;
  }
  getfileSharePath() {
    return this.dataSrv.windowFileSharePath;
  }

  getWorkbookBatchkeys(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIG_WORKBOOK_DATA +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this.dataSrv.loggedUserId,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getWorkbookExtractBatchkeys(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIG_WORKBOOK_BATCH_KEYS_REV +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this.dataSrv.loggedUserId,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getExtractBatchKeys(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIG_WORKBOOK_BATCH_KEY_EXTRACT_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this.dataSrv.loggedUserId,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getCreateBatchkeys(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_BATCHKEY_UI +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this.dataSrv.loggedUserId,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_ConfigWorkbook,
      Source: 'CLOUD',
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getInstanceDetails(type: string): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_INSTANCE_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Source_Type: type,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getConfigDetails(type: string): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIG_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Request_Type: type,
      Extract_Application:
        DconConfigAPI.API_VARIABLES.Request_Type_ConfigWorkbook,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }
  onConfigSubmit(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.INSERT_CONFIGBOOK_INSERT_BATCHKEY +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }

  onWorbookSubmit(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.INSERT_CONFIGBOOK_REVERSE_INSERT_BATCHKEY +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }

  getWorkbookConfigDetails(batchKey): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.CONGIGBOOK_CONFIG_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Batch_Key: batchKey,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  async uploadFileFromSFTP(formData) {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.UPLOAD_WORKBOOK;
    const req = new HttpRequest('POST', url, formData, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',

        ignoreInInterceptor: 'true',
      }),
    });
    return await this.https.request(req);
  }

  // async uploadFileFromWorkbook(formData) {
  //   const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.UPLOAD_WORKBOOK;
  //   const req = new HttpRequest('POST', url, formData, {
  //     headers: new HttpHeaders({
  //       'Access-Control-Allow-Origin': '*',
  //       'ignoreInInterceptor': 'true'
  //     })
  //   });
  //   return await this.https.request(req);
  // }

  async uploadFileFromWorkbook(formData): Promise<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.UPLOAD_WORKBOOK;

    let headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      ignoreInInterceptor: 'true',
    });

    if (environment.isBasicAuth) {
      headers = headers.append(
        'Authorization',
        `Bearer ${this.localstorageToken}`
      );

      formData.append('isBasicAuth', 'true');
    }

    const req = new HttpRequest('POST', url, formData, { headers });
    console.log('Making service call with request:', req);

    return this.https.request(req);
  }

  // async onSubmit(batchKey) {
  //   const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.CREATE_WORKBOOK;
  //   const obj = {
  //     "batchKey": batchKey,
  //     "RequestType": "generateWorkbook",
  //     "RequestedBy": this.requestedBy
  //   };

  //   const req = new HttpRequest('POST', url, obj, {
  //     headers: new HttpHeaders({
  //       'Access-Control-Allow-Origin': '*',
  //       'ignoreInInterceptor': 'true'
  //     })
  //   });
  //   return await this.https.request(req);
  // }
 
  async onSubmit(batchKey): Promise<Observable<any>> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.CREATE_WORKBOOK;

    const obj: any = {
        batchKey: batchKey,
        RequestType: "generateWorkbook",
        RequestedBy: this.requestedBy
    };

    let headers = new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'ignoreInInterceptor': 'true'
    });

    if (environment.isBasicAuth) {
        const token = localStorage.getItem('authToken');
        headers = headers.append('Authorization', `Bearer ${token}`);
        obj.isBasicAuth = true;
    }

    const req = new HttpRequest('POST', url, obj, { headers });

    console.log('Making service call with request:', req); // Debugging step
    return this.https.request(req);
}

  // async onSubmitForCSVWorkbook(batchKey) {
  //   const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.CREATE_WORKBOOKEXTRACT;
  //   const obj = {
  //     "batchKey": batchKey,
  //     "RequestType": "generateExtract",
  //     "RequestedBy": this.requestedBy
  //   };

  //   const req = new HttpRequest('POST', url, obj, {
  //     headers: new HttpHeaders({
  //       'Access-Control-Allow-Origin': '*',
  //       'ignoreInInterceptor': 'true'
  //     })
  //   });
  //   return await this.https.request(req);
  // }
  async onSubmitForCSVWorkbook(batchKey) {
    const url =
      this.nodeBaseUrl + DconConfigAPI.URL_PROPS.CREATE_WORKBOOKEXTRACT;
    const obj = {
      batchKey: batchKey,
      RequestType: 'generateExtract',
      RequestedBy: this.requestedBy,
    };

    let headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      ignoreInInterceptor: 'true',
    });

    if (environment.isBasicAuth) {
      headers = headers.append(
        'Authorization',
        `Bearer ${this.localstorageToken}`
      );

      obj['isBasicAuth'] = true;
    }

    const req = new HttpRequest('POST', url, obj, { headers });

    return await this.https.request(req);
  }

  // downloadFiles(payloadObj): Observable<any> {
  //   const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.DOWNLOAD_WORKBOOK;

  //   return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  // }
  downloadFiles(payloadObj): Observable<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.DOWNLOAD_WORKBOOK;

    if (environment.isBasicAuth) {
      let headers = new HttpHeaders({
        Authorization: `Bearer ${this.localstorageToken}`,
      });

      payloadObj['isBasicAuth'] = true;

      return this.https.post(url, payloadObj, {
        headers,
        responseType: 'arraybuffer',
      });
    }

    return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  }

  // downloadFilesForCsvExtract(payloadObj): Observable<any> {
  //   const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.DOWNLOAD_WORKBOOKEXTRACT;

  //   return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  // }
  downloadFilesForCsvExtract(payloadObj): Observable<any> {
    const url =
      this.nodeBaseUrl + DconConfigAPI.URL_PROPS.DOWNLOAD_WORKBOOKEXTRACT;

    if (environment.isBasicAuth) {
      const token = localStorage.getItem('authToken');

      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });

      payloadObj['isBasicAuth'] = true;

      return this.https.post(url, payloadObj, {
        headers,
        responseType: 'arraybuffer',
      });
    }

    return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  }

  onWorbookSubmitForLineTable(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.CONGIGBOOK_INSERT_LINE_CONFIG_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }

  onWorkbookUpdate(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.CONGIGBOOK_UPDATE_WORKBOOK_TEMPLATE +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Batch_Key: this.batchKey,
    });
    const options = { headers: headers };
    return this.https.put(url, body, options);
  }

  onGenerateUpdate(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.UPDATE_BATCHKEY_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.put(url, body, options);
  }

  Submit(body): Observable<any> {
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.INSERT_BATCHKEY_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }

  getConfigTemplatePath() {
    return this.dataSrv.configTemplatePath;
  }

  getSelectedBatchTasks(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_BATCHKEY_DATA +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this.dataSrv.loggedUserId,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_Extract,
      Source_Type: DconConfigAPI.API_VARIABLES.WORKBOOK,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  // downloadTemplates(payloadObj): Observable<any> {
  //   const url = DconConfigAPI.NODE_URL + DconConfigAPI.URL_PROPS.WORKBOOK_TEMPLATE_DOWNLOAD;//"http://localhost:5007/Bot/downloadFile";
  //   return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  // }
  downloadTemplates(payloadObj): Observable<any> {
    const url =
      DconConfigAPI.NODE_URL +
      DconConfigAPI.URL_PROPS.WORKBOOK_TEMPLATE_DOWNLOAD;

    if (environment.isBasicAuth) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.localstorageToken}`,
      });

      payloadObj['isBasicAuth'] = true;

      return this.https.post(url, payloadObj, {
        headers,
        responseType: 'arraybuffer',
      });
    }

    return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  }
}
